<script>
import medicationService from "@/services/medication";
import debounce from "debounce";
import programMedications from "@/components/ui/program-medications.json";

const DEBOUNCE_MS_TIMEOUT = 500;

export default {
  name: "MedicationSelect",
  props: {
    value: { type: String, default: "" },
    readonly: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    isProgram: { type: Boolean, default: false },
    programName: { type: String, default: "" },
  },
  data() {
    return {
      medications: [],
      isLoading: false,
    };
  },
  computed: {
    findMedicationById() {
      const med = this.medications.find((m) => m._id === this.value);
      return med ? med.name : "Sin datos";
    },
  },

  watch: {
    programName() {
      this.medications = [];
    },
  },

  methods: {
    async getMedications(query) {
      if (!query || !query.trim()) {
        this.medications = [];
        return;
      }

      this.isLoading = true;
      try {
        if (this.isProgram) {
          const q = query.toLowerCase();
          this.medications = programMedications.filter((m) => {
            const matchesText = m.name.toLowerCase().includes(q);
            const matchesProgram =
              !this.programName ||
              m.programa.toLowerCase() === this.programName.toLowerCase();

            return matchesText && matchesProgram;
          });
        } else {
          const filter = { name: { $regex: query, $options: "i" } };
          const result = await medicationService.getMedications(filter);
          this.medications = result;
        }
      } catch (err) {
        console.error("Error fetching medications:", err);
      }
      this.isLoading = false;
      this.$emit("loadedMedications", this.medications);
    },
    debounceSelect: debounce(function (query) {
      this.getMedications(query);
    }, DEBOUNCE_MS_TIMEOUT),
    onInput(value) {
      const selected = this.medications.find((m) => m._id === value);
      if (selected && !this.$store.state.cacheMedications?.[value]) {
        this.$store.dispatch("addMedication", selected);
      }
      this.$emit("input", value);
    },

    /**
     * @description Pre-filtra el selector con el término sugerido por la IA.
     *              No auto-selecciona porque ALFABETA tiene múltiples presentaciones
     *              del mismo principio activo — el médico elige la exacta.
     * @param {string} term - Nombre del medicamento sugerido por la IA
     */
    async triggerAISearch(term) {
      if (!term) return;
      await this.getMedications(term);
    },
  },
};
</script>

<template lang="pug">
.medications
  el-select(
    v-if="!readonly"
    :value="value"
    @input="onInput"
    filterable
    remote
    :remote-method="debounceSelect"
    :loading="isLoading"
    :disabled="isDisabled"
    placeholder="Ingrese un medicamento"
  )
    el-option(
      v-for="med in medications"
      :key="med._id"
      :label="med.name"
      :value="med._id"
    )

  el-input(
    v-else
    :value="findMedicationById"
    readonly
  )
</template>

<style scoped>
.medications {
  width: 100%;
}
</style>
